import SimpleManaNode, { SimpleManaNodeOptions } from "./SimpleManaNode"

export type ManaZoneNodeOptions = {} & SimpleManaNodeOptions

export default class ManaZoneNode extends SimpleManaNode {

}